export default "__VITE_ASSET__b52mWmIQ__"